<style>
	@import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Whitelisting" title="New Whitelisting Request" />
 
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					
					<div class="card">
						<div class="card-body">

							<form @submit.prevent="fetchWhitelistData" enctype="multipart/form-data">
								<div class="row">
									<div class="col-md-3">
										<div class="mb-3">
										<label class="control-label">ICCID/IMEI<span class="text-danger">*</span></label>
										<input class="form-control" type="text" v-model="po_number" placeholder=""/>
										</div>
									</div>

									<div class="col-md-2 align-items-end" style="margin-top: 32px;">
										<div class="mb-3">
											<button class="btn btn-warning me-2" type="submit">Submit</button>
										</div>
									</div>

									<div class="col-md-1"></div>

									<div class="col-md-6" v-if="iccid">
										<div class="table-responsive">
											<table class="table submit table-borderless table-sm mb-0">
												<tbody>
													<tr>
														<th class="fw-bold text-nowrap" style="width: 100px;">ICCID:</th>
														<td class="fw-normal ps-3">{{ iccid }}</td>
													</tr>
													<tr>
														<th class="fw-bold text-nowrap" style="width: 100px;">MSISDN Number 1:</th>
														<td class="fw-normal ps-3">{{ msisdn1 }}</td>
													</tr>
													<tr>
														<th class="fw-bold text-nowrap" style="width: 100px;">MSISDN Number 2:</th>
														<td class="fw-normal ps-3">{{ msisdn2 }}</td>
													</tr>
												</tbody>
											</table>
										</div>
										<!-- <div class="row ms-5">
											<div class="mb-2">
												<strong>ICCID :</strong> {{ iccid }}
											</div>
											<div class="mb-2">
												<strong>MSISDN Number 1 :</strong> {{ msisdn1 }}
											</div>
											<div class="mb-2">
												<strong>MSISDN Number 2 :</strong> {{ msisdn2 }}
											</div>
										</div> -->
									</div>

								</div>
							</form>

							<div class="row mt-4" v-if="mobileNumbers.length || ipAddresses.length">
								<div class="col-12 p-3" style="border: 1px dashed orange; border-radius: 6px;">
									<!-- Headings -->
									<div class="row text-center fw-bold mb-3">
										<div class="col-md-6 fs-5 text-secondary">Mobile Number</div>
										<div class="col-md-6 fs-5 text-secondary">IP</div>
									</div>

									<!-- Numbers and IPs rows -->
									<div class="row mb-1" >
										<div class="col-md-6">
											<div class="table-responsive"  v-for="(number, index) in mobileNumbers" :key="index">
												<table class="table submit table-borderless table-sm mb-0">
													<tbody>
														<tr>
															<th scope="row" class="fw-bold" style="width: 300px;">Number{{ index + 1 }}:</th>
															<td class="fw-normal">{{ number }}</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
										
										<div class="col-md-6">
											<div class="table-responsive" v-for="(ip, index) in ipAddresses" :key="index">
												<table class="table submit table-borderless table-sm mb-0">
													<tbody>
														<tr>
															<th class="fw-bold text-nowrap" style="width: 300px;">IP{{ index + 1 }}:</th>
															<td class="fw-normal ps-3">{{ ip }}</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>

				</div>
			</div>
		</div>

   </div>
</template>


<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "",
		
		data() {
	      
			return {
				po_number: '',
				iccid: '',
				msisdn1: '',
				msisdn2: '',
				mobileNumbers: [],
				ipAddresses: []


			};
		},
		mounted() {},

		created() {

		},

		methods: {

			getToken() {
				if (localStorage.getItem('trazio')) {
				var trazio =  JSON.parse(localStorage.getItem('trazio'));
				if(trazio.token) {

					this.token = trazio.token;
					this.user = trazio;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}

				} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
				}
			},

			fetchWhitelistData() {
				this.getToken();

				const config = {
					headers: {
						Accept: 'application/json',
						Authorization: 'Bearer ' + this.token, 
					},
				};

				let url = "/trazio/viewWhitelisting?&value=" + this.po_number; 

				this.$axios
					.get(url, config)
					.then((res) => {
						const data = res.data.data; 

						this.iccid = data.primary_ICCID || '';
						this.msisdn1 = data.primary_MSISDN  || '';
						this.msisdn2 = data.secondary_MSISDN  || '';
						this.mobileNumbers = data.mobileNumbers || [];
						this.ipAddresses = data.ipAddresses || [];
					})
					.catch((err) => {
						console.error(err);
						this.$swal('Error', 'Failed to fetch whitelist data.', 'error');
					});
			},
				
		},
	};
</script>
